(() => {
  const grid = document.querySelector('[data-wishlist-grid]');
  const empty = document.querySelector('[data-wishlist-empty]');
  if (!grid) return;

  const key = 'azurialWishlistHandles';
  const getList = () => { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch { return []; } };
  const setList = list => localStorage.setItem(key, JSON.stringify(list));
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style:'currency', currency:'EUR' }).format((Number(cents)||0)/100);

  let actionBar = null;
  let addButton = null;
  let selectionCount = null;
  let confirmPopover = null;
  let pendingRemoveHandle = null;

  const ensureActionBar = () => {
    if (actionBar) return;
    const sectionContainer = grid.closest('.container') || grid.parentElement;
    actionBar = document.createElement('div');
    actionBar.className = 'az-wishlist-selection-bar';
    actionBar.hidden = true;
    actionBar.innerHTML = `
      <span class="az-wishlist-selection-bar__count" data-wishlist-selection-count>0 sélectionné</span>
      <button class="az-wishlist-selection-bar__add" type="button" data-wishlist-add-selected>Ajouter la sélection au panier</button>`;
    sectionContainer.insertBefore(actionBar, grid);
    addButton = actionBar.querySelector('[data-wishlist-add-selected]');
    selectionCount = actionBar.querySelector('[data-wishlist-selection-count]');
  };

  const ensureConfirmPopover = () => {
    if (confirmPopover) return;
    confirmPopover = document.createElement('div');
    confirmPopover.className = 'az-wishlist-confirm';
    confirmPopover.hidden = true;
    confirmPopover.innerHTML = `
      <div class="az-wishlist-confirm__panel" role="dialog" aria-modal="true" aria-label="Retirer des favoris">
        <p>Retirer cet article des favoris ?</p>
        <div class="az-wishlist-confirm__actions">
          <button type="button" class="az-wishlist-confirm__cancel" data-wishlist-cancel-remove>Annuler</button>
          <button type="button" class="az-wishlist-confirm__remove" data-wishlist-confirm-remove>Retirer</button>
        </div>
      </div>`;
    document.body.appendChild(confirmPopover);
  };

  async function fetchProduct(handle){
    const r = await fetch(`/products/${encodeURIComponent(handle)}.js`, { headers:{Accept:'application/json'} });
    if (!r.ok) throw new Error('product');
    return r.json();
  }

  function variantsMarkup(product){
    const available = (product.variants || []).filter(v => v.available);
    if (available.length <= 1) return '';
    return `<label class="az-wishlist-live-card__variant" hidden>
      <span>Option</span>
      <select data-wishlist-variant aria-label="Choisir une option pour ${product.title.replace(/"/g,'&quot;')}">
        ${available.map(v => `<option value="${v.id}">${v.public_title || v.title}</option>`).join('')}
      </select>
    </label>`;
  }

  function card(product){
    const image = product.featured_image || product.images?.[0] || '';
    const url = product.url || `/products/${product.handle}`;
    const type = product.type || '';
    const available = (product.variants || []).filter(v => v.available);
    const defaultVariant = available[0]?.id || product.variants?.[0]?.id || '';
    return `<article class="az-wishlist-live-card" data-wishlist-live-card="${product.handle}" data-default-variant="${defaultVariant}">
      <div class="az-wishlist-live-card__media">
        <a href="${url}" aria-label="${product.title.replace(/"/g,'&quot;')}">${image ? `<img src="${image}" alt="${product.title.replace(/"/g,'&quot;')}" loading="lazy">` : ''}</a>
        <label class="az-wishlist-live-card__select" aria-label="Sélectionner ${product.title.replace(/"/g,'&quot;')}">
          <input type="checkbox" data-wishlist-select>
          <span aria-hidden="true"></span>
        </label>
        <button class="az-wishlist-live-card__remove is-active" type="button" data-wishlist-remove="${product.handle}" aria-label="Retirer des favoris" aria-pressed="true"><span aria-hidden="true">♥</span></button>
      </div>
      <div class="az-wishlist-live-card__meta">
        <div><a href="${url}">${product.title}</a>${type ? `<small class="az-wishlist-live-card__type">${type}</small>` : ''}</div>
        <span>${money(product.price)}</span>
      </div>
      ${variantsMarkup(product)}
    </article>`;
  }

  function updateSelectionUI(){
    ensureActionBar();
    const selected = [...grid.querySelectorAll('[data-wishlist-select]:checked')];
    actionBar.hidden = selected.length === 0;
    selectionCount.textContent = `${selected.length} sélectionné${selected.length > 1 ? 's' : ''}`;
    selected.forEach(input => {
      const card = input.closest('[data-wishlist-live-card]');
      const chooser = card?.querySelector('.az-wishlist-live-card__variant');
      if (chooser) chooser.hidden = false;
    });
    grid.querySelectorAll('[data-wishlist-select]:not(:checked)').forEach(input => {
      const chooser = input.closest('[data-wishlist-live-card]')?.querySelector('.az-wishlist-live-card__variant');
      if (chooser) chooser.hidden = true;
    });
  }

  async function addSelectedToCart(){
    const selectedCards = [...grid.querySelectorAll('[data-wishlist-select]:checked')].map(input => input.closest('[data-wishlist-live-card]')).filter(Boolean);
    if (!selectedCards.length) return;

    const items = selectedCards.map(card => {
      const chooser = card.querySelector('[data-wishlist-variant]');
      const id = Number(chooser?.value || card.dataset.defaultVariant);
      return id ? { id, quantity: 1 } : null;
    }).filter(Boolean);

    if (!items.length) return;

    addButton.disabled = true;
    addButton.textContent = 'Ajout…';
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error('cart');
      window.location.href = '/cart';
    } catch {
      addButton.disabled = false;
      addButton.textContent = 'Ajouter la sélection au panier';
    }
  }

  function syncHearts(handle, active){
    document.querySelectorAll(`[data-az-wish="${CSS.escape(handle)}"]`).forEach(button => {
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? 'Retirer des favoris' : 'Ajouter aux favoris');
      button.textContent = active ? '♥' : '♡';
    });
    document.dispatchEvent(new CustomEvent('azurial:wishlist-change', { detail: { handles: getList() } }));
  }

  function openRemoveConfirm(handle){
    ensureConfirmPopover();
    pendingRemoveHandle = handle;
    confirmPopover.hidden = false;
    requestAnimationFrame(() => confirmPopover.classList.add('is-open'));
  }

  function closeRemoveConfirm(){
    if (!confirmPopover) return;
    confirmPopover.classList.remove('is-open');
    setTimeout(() => { if (confirmPopover) confirmPopover.hidden = true; }, 160);
    pendingRemoveHandle = null;
  }

  function confirmRemove(){
    if (!pendingRemoveHandle) return;
    const handle = pendingRemoveHandle;
    const next = getList().filter(h => h !== handle);
    setList(next);
    syncHearts(handle, false);
    closeRemoveConfirm();
    render();
  }

  async function render(){
    const handles = getList();
    grid.innerHTML = '';
    ensureActionBar();
    actionBar.hidden = true;
    if (!handles.length) {
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    const products = (await Promise.all(handles.map(h => fetchProduct(h).catch(() => null)))).filter(Boolean);
    const validHandles = products.map(p => p.handle);
    if (validHandles.length !== handles.length) setList(validHandles);
    if (!products.length) {
      if (empty) empty.hidden = false;
      return;
    }
    grid.innerHTML = products.map(card).join('');
  }

  grid.addEventListener('change', e => {
    if (e.target.matches('[data-wishlist-select]')) updateSelectionUI();
  });

  grid.addEventListener('click', e => {
    const btn = e.target.closest('[data-wishlist-remove]');
    if (!btn) return;
    e.preventDefault();
    openRemoveConfirm(btn.dataset.wishlistRemove);
  });

  document.addEventListener('click', e => {
    if (e.target.closest('[data-wishlist-add-selected]')) addSelectedToCart();
    if (e.target.closest('[data-wishlist-confirm-remove]')) confirmRemove();
    if (e.target.closest('[data-wishlist-cancel-remove]')) closeRemoveConfirm();
    if (confirmPopover && e.target === confirmPopover) closeRemoveConfirm();
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && confirmPopover && !confirmPopover.hidden) closeRemoveConfirm();
  });

  render();
})();
